// import React, { useState, useEffect } from "react";
// import MetisMenu from "metismenujs";
// import { Link, useLocation } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import { connect } from "react-redux";
// import {
//   changeLayout,
//   changeLayoutWidth,
//   changeSidebarTheme,
//   changeSidebarType,
//   changePreloader,
// } from "../../store/actions";
// import { getRecords } from "../../services/api.service";

// const SidebarContent = (props) => {
//   const [menuData, setMenuData] = useState([]);
//   const [accesMenuData, setAccesMenuData] = useState([]);
//   const { t } = useTranslation();
//   const currentPath = useLocation().pathname;

//   useEffect(() => {
//     const fetchMenuData = async () => {
//       try {
//         const payload = {
//           modelName: "menu_masters",
//           whereCondition: { is_active: true },
//           pagination: { page: 1, pageSize: 1000000 },
//         };

//         const responseData = await getRecords(payload, "/getRecords");
//         if (responseData.code === 1) {
//           responseData.data.forEach((element, index) => {
//             element.index = index + 1;
//           });
//           setMenuData(responseData.data);
//         }
//       } catch (error) {
//         console.error("Error fetching menu data:", error);
//       }
//     };

//     const fetchAccessMenuData = async () => {
//       try {
//         let authID = JSON.parse(localStorage.getItem("userDetails"));
//         const payload = {
//           modelName: "user_access",
//           whereCondition: {
//             user_id: authID.id,
//             access: true,
//             is_active: true,
//           },
//           pagination: { page: 1, pageSize: 1000000 },
//         };
//         const responseData = await getRecords(payload, "/getRecords");
//         if (responseData.code === 1) {
//           setAccesMenuData(responseData.data);
//         }
//       } catch (error) {
//         console.error("Error fetching access menu data:", error);
//       }
//     };

//     Promise.all([fetchMenuData(), fetchAccessMenuData()]).then(() => {
//       initMenu();
//     });
//   }, []);

//   useEffect(() => {
//     if (menuData.length > 0 && accesMenuData.length > 0) {
//       initMenu();
//     }
//   }, [menuData, accesMenuData]);

//   const initMenu = () => {
//     new MetisMenu("#side-menu", {
//       toggle: true,
//     });
//   };

//   const accessMenuId = accesMenuData.map((item) => item.menu_id);
//   const filteredMenuData = menuData.filter((item) =>
//     accessMenuId.includes(item.id)
//   );

//   const activeStyle = {
//     color: "white",
//   };

//   return (
//     <div id="sidebar-menu">
//       <ul className="metismenu list-unstyled" id="side-menu">
//         <li className="menu-title">{t("Menu")}</li>
//         {/* <li>
//           <Link to="/dashboard" className="waves-effect">
//             <i className="ri-dashboard-line"></i>
//             <span className="ms-1">{t("Dashboard")}</span>
//           </Link>
//         </li> */}
//         {filteredMenuData
//           .filter(
//             (item) =>
//               item.parent_id === null ||
//               filteredMenuData.some((child) => child.parent_id === item.id)
//           )
//           .sort((a, b) => a.sequence - b.sequence)
//           .map((item) => (
//             <li key={item.id}>
//               <Link
//                 to={item.menu_url || "#"}
//                 className={
//                   filteredMenuData.some((child) => child.parent_id === item.id)
//                     ? "has-arrow waves-effect"
//                     : "waves-effect"
//                 }
//                 style={currentPath === item.menu_url ? activeStyle : {}}
//               >
//                 <i className={item.menu_icon}></i>
//                 <span className="ms-1">{t(item.menu_name)}</span>
//               </Link>

//               {filteredMenuData.some(
//                 (child) => child.parent_id === item.id
//               ) && (
//                 <ul className="sub-menu">
//                   {filteredMenuData
//                     .filter((child) => child.parent_id === item.id)
//                     .sort((a, b) => a.sequence - b.sequence)
//                     .map((child) => (
//                       <li key={child.id}>
//                         <Link
//                           to={child.menu_url}
//                           style={
//                             currentPath === child.menu_url ? activeStyle : {}
//                           }
//                         >
//                           {t(child.menu_name)}
//                         </Link>
//                       </li>
//                     ))}
//                 </ul>
//               )}
//             </li>
//           ))}
//       </ul>
//     </div>
//   );
// };

// const mapStatetoProps = (state) => {
//   return { ...state.Layout };
// };

// export default connect(mapStatetoProps, {
//   changeLayout,
//   changeSidebarTheme,
//   changeSidebarType,
//   changeLayoutWidth,
//   changePreloader,
// })(SidebarContent);

import React, { useState, useEffect } from "react";
import MetisMenu from "metismenujs";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader,
} from "../../store/actions";
import { getRecords } from "../../services/api.service";

const SidebarContent = (props) => {
  const [menuData, setMenuData] = useState([]);
  const [accesMenuData, setAccesMenuData] = useState([]);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();
  const currentPath = useLocation().pathname;

  useEffect(() => {
    const fetchMenuData = async () => {
      try {
        const payload = {
          modelName: "menu_masters",
          whereCondition: { is_active: true },
          pagination: { page: 1, pageSize: 1000000 },
        };

        const responseData = await getRecords(payload, "/getRecords");
        if (responseData.code === 1) {
          responseData.data.forEach((element, index) => {
            element.index = index + 1;
          });
          setMenuData(responseData.data);
          return true;
        }
      } catch (error) {
        console.error("Error fetching menu data:", error);
        return false;
      }
    };

    const fetchAccessMenuData = async () => {
      try {
        let authID = JSON.parse(localStorage.getItem("userDetails"));
        const payload = {
          modelName: "user_access",
          whereCondition: {
            user_id: authID.id,
            access: true,
            is_active: true,
          },
          pagination: { page: 1, pageSize: 1000000 },
        };
        const responseData = await getRecords(payload, "/getRecords");
        if (responseData.code === 1) {
          setAccesMenuData(responseData.data);
          return true;
        }
      } catch (error) {
        console.error("Error fetching access menu data:", error);
        return false;
      }
    };

    const loadData = async () => {
      setLoading(true);
      try {
        await Promise.all([fetchMenuData(), fetchAccessMenuData()]);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  useEffect(() => {
    if (menuData.length > 0 && accesMenuData.length > 0) {
      initMenu();
    }
  }, [menuData, accesMenuData]);

  const initMenu = () => {
    new MetisMenu("#side-menu", {
      toggle: true,
    });
  };

  // Skeleton loading styles
  const skeletonStyle = {
    backgroundColor: "#f0f0f0",
    borderRadius: "4px",
    position: "relative",
    overflow: "hidden",
    background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
    backgroundSize: "200% 100%",
    animation: "shimmer 1.5s infinite linear",
  };

  const activeStyle = {
    color: "white",
  };

  if (loading) {
    return (
      <div id="sidebar-menu">
        <style>
          {`
            @keyframes shimmer {
              to { background-position: -200% 0; }
            }
          `}
        </style>
        <ul className="metismenu list-unstyled" id="side-menu">
          <li className="menu-title" style={{ padding: "12px 20px" }}>
            <div
              style={{ ...skeletonStyle, width: "80px", height: "20px" }}
            ></div>
          </li>

          {[...Array(6)].map((_, i) => (
            <li key={`skeleton-${i}`} style={{ padding: "10px 20px" }}>
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    ...skeletonStyle,
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    marginRight: "12px",
                  }}
                ></div>
                <div
                  style={{
                    ...skeletonStyle,
                    width: i % 2 === 0 ? "160px" : "120px",
                    height: "16px",
                  }}
                ></div>
              </div>

              {i % 3 === 0 && (
                <ul
                  className="sub-menu"
                  style={{ paddingLeft: "36px", marginTop: "8px" }}
                >
                  {[...Array(3)].map((_, j) => (
                    <li key={`sub-skeleton-${j}`} style={{ padding: "6px 0" }}>
                      <div
                        style={{
                          ...skeletonStyle,
                          width: j % 2 === 0 ? "120px" : "100px",
                          height: "14px",
                        }}
                      ></div>
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  const accessMenuId = accesMenuData.map((item) => item.menu_id);
  const filteredMenuData = menuData.filter((item) =>
    accessMenuId.includes(item.id)
  );

  return (
    <div id="sidebar-menu">
      <ul className="metismenu list-unstyled" id="side-menu">
        <li className="menu-title">{t("Menu")}</li>

        {filteredMenuData
          .filter(
            (item) =>
              item.parent_id === null ||
              filteredMenuData.some((child) => child.parent_id === item.id)
          )
          .sort((a, b) => a.sequence - b.sequence)
          .map((item) => (
            <li key={item.id}>
              <Link
                to={item.menu_url || "#"}
                className={
                  filteredMenuData.some((child) => child.parent_id === item.id)
                    ? "has-arrow waves-effect"
                    : "waves-effect"
                }
                style={currentPath === item.menu_url ? activeStyle : {}}
              >
                <i className={item.menu_icon}></i>
                <span className="ms-1">{t(item.menu_name)}</span>
              </Link>

              {filteredMenuData.some(
                (child) => child.parent_id === item.id
              ) && (
                <ul className="sub-menu">
                  {filteredMenuData
                    .filter((child) => child.parent_id === item.id)
                    .sort((a, b) => a.sequence - b.sequence)
                    .map((child) => (
                      <li key={child.id}>
                        <Link
                          to={child.menu_url}
                          style={
                            currentPath === child.menu_url ? activeStyle : {}
                          }
                        >
                          {t(child.menu_name)}
                        </Link>
                      </li>
                    ))}
                </ul>
              )}
            </li>
          ))}
      </ul>
    </div>
  );
};

const mapStatetoProps = (state) => {
  return { ...state.Layout };
};

export default connect(mapStatetoProps, {
  changeLayout,
  changeSidebarTheme,
  changeSidebarType,
  changeLayoutWidth,
  changePreloader,
})(SidebarContent);
